module.exports = __webpack_public_path__ + "img/chanpin-belt.da59302f.jpg";